// TODO: refactor slot imports
import {Message} from '@gongxigames/framework/slot/types';

export type MessageEvents = {
    'General.Message.SHOW': Message;
    'General.Message.CLOSE': Message | void;
};
